module.exports = __webpack_public_path__ + "static/1327703255.81c7bf66.jpg";